import { render, staticRenderFns } from "./commoncheckout.vue?vue&type=template&id=31f4529c&scoped=true"
import script from "./commoncheckout.vue?vue&type=script&lang=js"
export * from "./commoncheckout.vue?vue&type=script&lang=js"
import style0 from "./commoncheckout.vue?vue&type=style&index=0&id=31f4529c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f4529c",
  null
  
)

export default component.exports